import React from "react";

import Box from "@mui/material/Box";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import { PlanOption } from "../variables";

interface SubscriptionItemSelectProps {
  cardId?: string;
  selectedPlanId?: string;
  onChange: (id: string) => void;
  options: PlanOption[];
}

const SubscriptionItemSelect: React.FC<SubscriptionItemSelectProps> = ({
  cardId,
  options,
  selectedPlanId,
  onChange,
}) => {
  const handleSelectChange = (event: SelectChangeEvent<string>) => {
    onChange(event.target.value as string);
  };

  return (
    <Select
      data-testid={cardId ? `select-${cardId}` : undefined}
      value={selectedPlanId}
      onChange={handleSelectChange}
      MenuProps={{ PaperProps: { sx: { p: "0 !important" } } }}
      fullWidth
      renderValue={(value) => {
        const current = options.find((item) => item.id === value);

        return (
          <Box>
            <Typography>{current?.title}</Typography>
            <Typography variant="subtitle2" color="grey700">
              {current?.description}
            </Typography>
          </Box>
        );
      }}
      slotProps={{ input: { sx: { p: "8px 16px" } } }}
      sx={{ mb: 1 }}
    >
      {options.map((option) => (
        <MenuItem
          key={`select-${option.id}`}
          data-testid={`select-item-${option.id}`}
          value={option.id}
        >
          <Box>
            <Typography>{option.title}</Typography>
            <Typography variant="subtitle2" color="grey700">
              {option.description}
            </Typography>
          </Box>
        </MenuItem>
      ))}
    </Select>
  );
};

export default SubscriptionItemSelect;
